// extracted by mini-css-extract-plugin
export default {"root":"TaskAttributes_root__2m6Jq","accordionLabel":"TaskAttributes_accordionLabel__aZjdd"};